import React, { useState, useEffect, Fragment } from 'react';
import {
  Card,
  CardBody,
  Button,
  TabContent,
  TabPane,
  NavItem,
  CardHeader,
  Nav,
  Row,
  NavLink,
  Tab,
  Navbar
} from 'reactstrap';
import XolaLogo from '../images/xola.png';
import stripe_logo from "../../../../../assets/stripe_logo.jpg";
import aiva_logo from "../../../../../assets/aiva_logo_large.jpg";
import classnames from 'classnames';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import AddIntegration from './AddIntegration';
import MewsLogo from '../../../../../assets/mews_logo.png';
import CloudBeds_Logo from '../images/cloudBeds_logo.png';
import AddVoucherIntregation from './AddVoucherIntegration';
import AddVoucherStandlonePageIntegration from './AddVoucherStandAlonePageIntegration';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
  API_Ingetration,
  gAPI_Property_List,
  gAPI_Stripe_Connection,
  dAPI_Delete_Ingetration,
  postAPI_TrackEvent, 
} from '../../../../../constants/APIs';
import { faStripe,faPaypal, faGoogle } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import VoucherWebsiteIntregationThumb from './VoucherWebsiteIntregation';
import StripeIntregation from './StripeIntregation';
import OpenAccount from './OpenAccount';
import ShowMessage from './ShowMessage';
import StripeIntregationThumb from './StripeIntregrationThumb';
import SiteMinderLogo from '../../../../../assets/siteminder.svg';
import AmadeusLogo from '../../../../../assets/amadeus_logo.png';
import AmadeusIntegration from './AmadeusIntegration';
import AmadeusIntegrationThumb from './AmadeusIntegrationThumb';
import AddEmbedVoucherIntregation from './AddEmbedVoucherIntregation';
import EmbedVoucherWebsiteIntregationThumb from './EmbedVoucherWebsiteIntregationThumb';
import VoucherStandalonePageIntregationThumb from './VoucherStandalonePageIntregationThumb';
import XolaIntegration from './XolaIntegration';
import XolaIntegrationThumb from './XolaIntegrationThumb';
import CustomStripeIntegrationThumb from './CustomStripeIntegrationThumb';
import CustomStripeIntegration from './CustomStripeIntegration';
import StandardStripeIntregation from './StandardStripeIntregation';
import MewsIntegration from './MewsIntegration';
import MewsIntegrationThumb from './MewsIntegrationThumb';
import PayPalIntegration from './PayPalIntegration';
import PayPalIntegrationThumb from './PayPalIntegrationThumb';
import CloudsBedsIntegration from './CloudsBedsIntegration';
import CloudsBedsIntegrationThumb from './CloudsBedsIntegrationThumb';
import GTMIntegration from './GoogleTagManager/GTMIntegration';
import GTMIntegrationThumb from './GoogleTagManager/GTMIntegrationThumb';
function Integrations({ match, propertyId, email, isVoucherEngine, domains ,userRole}) {
  const [integrations, setIntegrations] = useState([]);
  const [stripeIntregation, setStripeIntregations] = useState([]);
  const [gbintegrations, setGbIntegrations] = useState([]);
  const [revinateintegrations, setRevinateIntegrations] = useState([]);
  const [weChatintegrations, setWeChatIntegrations] = useState([]);
  const [voucherWebsiteIntregation, setVoucherWebsiteIntregation] = useState(
    []
  );
  const [amadeusIntegration, setAmadeusIntegration] = useState([]);
  const [activeTab, setActiveTab] = useState('standard');
  const [allProperties, setAllProperties] = useState([]);
  const [isAdd, setIsAdd] = useState(false);
  const [messageVisible, setmessageVisible] = useState(
    localStorage.getItem('ShowMessage')
      ? localStorage.getItem('ShowMessage')
      : false
  );
  const [cloudBedsVisible, setCloudsBedsVisible] = useState(
    false
  );

  
  const [paymentmodelvisible, setpaymentmodelvisible] = useState(false);
  const [customStripe, setCustomStripeIntegration] = useState(false);
  const [createaccountModel, setcreateaccountModel] = useState(false);
  const [standardAccountModel, setStandardAccountModel] = useState(false);
  const [isConnected, setisConnected] = useState(false);
  const [stripeIntegrationId, setStripeIntegrationId] = useState('');
  const [standardStripeIntegrationId, setStandardStripeIntegrationId] = useState('');
  const [stripepropertyId, setStripeProprtyId] = useState('');
  const [isAddVouchers, setIsAddVouchers] = useState(false);
  const [isAddXola, setIsAddXola] = useState(false);
  const [customStripeIntegration_data, setCustomStripeIntegration_data] = useState([]);
  const [xolaIntegration, setXolaIntegration] = useState([]);
  const [isAddEmbedVoucher, setIsAddEmbedVoucher] = useState(false);
  const [embedVoucherIntregation, setEmbedVoucherIntregation] = useState(false);
  const [voucherStandalonePageIntregation, setVoucherStandalonePageIntregation] = useState(false);
  const [isAddStandalonePage, setIsAddStandalonePage] = useState(false);
  const [isAddAmadeus, setIsAmadeus] = useState(false);
  const [isAddCustomStripe, SetIsCustomStripe] = useState(false);
  const [isStandardStripe, SetIsStandardStripe] = useState(false);
  const [standardStripe, setStandardStripe] = useState(false);
  const [standardStripeIntregation, setStandardStripeIntregation] = useState([]);
  const [isMews,setIsMews]=useState(false);
  const [isPayPal,setIsPayPal]=useState(false);
  const [mewsIntegration,setMewsIntegration]=useState([]);
  const [isGTM,setIsGTM]=useState(false);  
  const [gTMIntegration,setGTMIntegration]=useState([]);
  const [payPalIntegration,setPayPalIntegration]=useState([]);
  const [cloudBeds,setCloudsBeds]=useState([]);
  const [isCloudBeds,setIsCloudsBeds]=useState(false);
  const [selectedTab,setSelectedTab]=useState('channels');
  const handleProerptyId = (id) => {
    setStripeProprtyId(id);
  };
  useEffect(() => {
    LoadIntegrations();   
    setTimeout(()=>{
      setCloudsBedsVisible(localStorage.getItem('ShowCloudbedsMessage')
      ? localStorage.getItem('ShowCloudbedsMessage')
      : false);
    },2000);
    if (email !== '') {
      AxiosAPI({
        method: 'post',
        url: `${postAPI_TrackEvent}`,
        data: {
          eventName: 'aiva Connect',
          email: email,
        },
      }).then(
        (res) => { },
        (error) => { }
      );
    }
  }, [propertyId]);

  const checkConnection = () => {
    let data = {
      GroupId: getGroupID(),
      PropertyId: propertyId,
    };
    AxiosAPI({
      method: 'post',
      url: `${gAPI_Stripe_Connection}/check`,
      data,
    })
      .then((m) => {
        if (m.data.stripeCustomerId == '') {
        }
        setStripeIntegrationId(m.data.stripeCustomerId);
      })
      .catch((err) => { });
  };
  const checkStandardConnection = () => {
    let data = {
      GroupId: getGroupID(),
      PropertyId: propertyId,
    };
    AxiosAPI({
      method: 'post',
      url: `${gAPI_Stripe_Connection}/check`,
      data,
    })
      .then((m) => {
        if (m.data.stripeCustomerId == '') {
        }
        setStandardStripeIntegrationId(m.data.stripeCustomerId);
      })
      .catch((err) => { });
  };
  const RefreshConnection = (status, id) => {
    let data = {
      GroupId: getGroupID(),
      PropertyId: propertyId,
      Creator: 'Admin',
      StripeCustomerId: status === 'Archieve' ? '' : stripeIntegrationId,
      StripeStatus: status,
    };
    AxiosAPI({
      method: 'post',
      url: `${gAPI_Stripe_Connection}/save`,
      data: data,
    })
      .then((res) => {
        if (status === 'Archieve') {
          AxiosAPI({
            method: 'delete',
            url: `${gAPI_Stripe_Connection}/remove?id=${id}`,
            data: data,
          })
            .then((res) => { })
            .catch((err) => { });
        }
      })
      .catch((err) => { });
  };
  const RefreshStandardConnection = (status, id) => {
    let data = {
      GroupId: getGroupID(),
      PropertyId: propertyId,
      Creator: 'Admin',
      StripeCustomerId: status === 'Archieve' ? '' : standardStripeIntegrationId,
      StripeStatus: status,
    };
    AxiosAPI({
      method: 'post',
      url: `${gAPI_Stripe_Connection}/save`,
      data: data,
    })
      .then((res) => {
        if (status === 'Archieve') {
          AxiosAPI({
            method: 'delete',
            url: `${gAPI_Stripe_Connection}/remove?id=${id}`,
            data: data,
          })
            .then((res) => { })
            .catch((err) => { });
        }
      })
      .catch((err) => { });
  };
  
  const handlePayment = () => {
    var restUrl = window.location.href.substring(
      0,
      window.location.href.lastIndexOf('/') + 1
    );
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Stripe_Connection}/url?url=${restUrl}stripe&state=${stripepropertyId}`,
    })
      .then((m) => {
        var restUrl = window.location.href.substring(
          0,
          window.location.href.lastIndexOf('/') + 1
        );
      window.location.href = m.data;      
      })
      .catch((err) => { });
  };
    
  const handleStandardPayment = () => {    
    var restUrl = window.location.href.substring(
      0,
      window.location.href.lastIndexOf('/') + 1
    );
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Stripe_Connection}/standard/url?url=${restUrl}standard-stripe&state=${stripepropertyId}`,
    })
      .then((m) => {
        var restUrl = window.location.href.substring(
          0,
          window.location.href.lastIndexOf('/') + 1
        );        
         window.location.href = m.data;
      })
      .catch((err) => { });
  };
  const LoadIntegrations = () => {
    let body={
      channels:['EmbedVoucher','VoucherStandAlonePage','Phone','GoogleBusinessMessage','Revinate','Stripe','Xola',
    'VoucherWebsite','CustomStripe','StandardStripe','Amadues','Mews','CloudBeds','PayPal','GoogleTagManager']
    };
    AxiosAPI({
      method: 'post',
      url: `${API_Ingetration}?group_id=${getGroupID()}`,
      data: body
    }).then((res) => {
    // AxiosAPI({
    //   method: 'get',
    //   url: `${gAPI_Ingetration}?group_id=${getGroupID()}`,
    // }).then((res) => {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List}/?group_id=${getGroupID()}`,
      }).then((result) => {        
      const embedVoucherIntregationData = res.data.filter(
        (k) => k.channel === 'EmbedVoucher'
      );
      const voucherStandalonePageIntegration = res.data.filter(
        (k) => k.channel === 'VoucherStandAlonePage'
      );
      const phoneIntegrationData = res.data.filter(
        (k) => k.channel === 'Phone'
      );
      const gbIntegrationData = res.data.filter(
        (k) => k.channel === 'GoogleBusinessMessage'
      );
      const revinateIntegrationData = res.data.filter(
        (k) => k.channel === 'Revinate'
      );
      const stripeIntregationData = res.data.filter(
        (k) => k.channel === 'Stripe'
      );
      const xolaIntegrationData = res.data.filter(
        (k) => k.channel === 'Xola'
      );
      const vouhcerWebisteIntregationData = res.data.filter(
        (k) => k.channel === 'VoucherWebsite'
      );
      const customStripeData = res.data.filter(
        (k) => k.channel === 'CustomStripe'
      );
      const standardStripeData = res.data.filter(
        (k) => k.channel === 'StandardStripe'
      );      
      const amadeusIntegration = res.data.filter(
        (k) => k.channel === "Amadues"  && 
          result.data.filter((a)=>k.properties.includes(a.id) && a.isAiva===true).length>0        
      );
      const mewsIntegration = res.data.filter(
        (k) => k.channel === "Mews"  && 
          result.data.filter((a)=>k.properties.includes(a.id)).length>0        
      );
      const cloudsBedsIntegration = res.data.filter(
        (k) => k.channel === "CloudBeds"      
      );            
      const payPalIntegrationData = res.data.filter(
        (k) => k.channel === "PayPal"  && 
          result.data.filter((a)=>k.properties.includes(a.id)).length>0        
      );
      const googleTagManagerIntegrationData = res.data.filter(
        (k) => k.channel === "GoogleTagManager"  && 
          result.data.filter((a)=>k.properties.includes(a.id)).length>0        
      );
      setGTMIntegration(googleTagManagerIntegrationData);
      setCloudsBeds(cloudsBedsIntegration);
      setPayPalIntegration(payPalIntegrationData);
      setMewsIntegration(mewsIntegration);
      setCustomStripeIntegration_data(customStripeData);
      setEmbedVoucherIntregation(embedVoucherIntregationData);
      setVoucherStandalonePageIntregation(voucherStandalonePageIntegration);
      setGbIntegrations(gbIntegrationData);
      setXolaIntegration(xolaIntegrationData);      
      setStripeIntregations(stripeIntregationData);
      setVoucherWebsiteIntregation(vouhcerWebisteIntregationData);
      setStandardStripeIntregation(standardStripeData);
      setAmadeusIntegration(amadeusIntegration);
    });
  });
  };
  const handleDelete = (id) => {
    AxiosAPI({
      method: 'delete',
      url: `${dAPI_Delete_Ingetration}/${id}/?group_id=${getGroupID()}`,
    }).then((res) => {
      LoadIntegrations();
    });
  };
  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Property_List}/?group_id=${getGroupID()}`,
    }).then((res) => {
      setAllProperties(res.data);
    });
    checkConnection();
    checkStandardConnection();
  }, []);
  const toggleAppMenu = (tab) => {
    setActiveTab(tab);
  };

  return (
    <Fragment>
      {/* <CardHeader className="pl-0 pr-0">
        <Nav tabs className="card-header-tabs ml-0 mr-0">
          <NavItem className="w-50 text-center">
            <NavLink
              className={classnames({
                active: activeTab === "standard",
                "nav-link": true
              })}
              onClick={() => {
                toggleAppMenu("standard");
              }}
              to="#"
            >
              Website Integrations
            </NavLink>
          </NavItem>
          <NavItem className="w-50 text-center">
            <NavLink
              className={classnames({
                active: activeTab === "embed",
                "nav-link": true
              })}
              onClick={() => {
                toggleAppMenu("embed");
              }}
              to="#"
            >
              Facebook Integrations
            </NavLink>
          </NavItem>
        </Nav>
      </CardHeader>
      <TabContent
        activeTab={activeTab}
        className=""
      >
        <TabPane tabId="standard" className="chat-app-tab-pane"> */}
      {/* <Row className="mt-2">
            <Colxx xxs="12">
              <Button
                color="primary"
                outline
                style={{
                  width: '100%',
                  borderRadius: '6px',
                }}
                className="mb-4"
                onClick={() => setIsAdd(!isAdd)}
              >
                <b>+ Add New Integration</b>
              </Button>
            </Colxx>
          </Row> */}
       <CardHeader className="mb-2" style={{ marginLeft: '-1.25rem', marginRight: '-1.25rem' }}>
        <Nav tabs className="card-header-tabs ml-0 mr-0">
          <NavItem className=" text-center" style={{ width: 'auto', background: '' }}>
            <NavLink
              style={{ background: 'none', cursor: 'pointer' }}
              className={classnames({
                active: selectedTab === "channels",
                "nav-link": true
              })}
              onClick={() => {
                setSelectedTab("channels");
              }}
              to="#"
            >
              <span style={{ color: `${selectedTab === "channels" ? '#EF4A81' : 'black'}` }}>Channels</span>
            </NavLink>
          </NavItem>
          <NavItem className=" text-center" style={{ width: 'auto' }}>
            <NavLink
              style={{ background: 'none', cursor: 'pointer' }}
              className={classnames({
                active: selectedTab === "applications",
                "nav-link": true
              })}
              onClick={() => {
                setSelectedTab("applications");
              }}
              to="#"
            >
              <span style={{ color: `${selectedTab === "applications" ? '#EF4A81' : 'black'}` }}>Applications</span>
            </NavLink>
          </NavItem>               
        </Nav>
      </CardHeader>

      <TabContent activeTab={selectedTab} className="">
        <TabPane tabId="channels" className="chat-app-tab-pane" style={{ background: "none" }}>
      
      {isAdd ? (
        <Row>
          <Colxx xxs="12">
            <Row>
              <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              <Colxx md="4" sm="4" lg="4" xxs="12">
                <AddIntegration
                  LoadIntegrations={LoadIntegrations}
                  visible={isAdd}
                  toggle={() => {
                    setIsAdd(!isAdd);
                  }}
                />
              </Colxx>
              <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
            </Row>
          </Colxx>
        </Row>
      ) : null}
       {isAddAmadeus ? (
        <Row>
          <Colxx xxs="12">
            <Row>
              <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              <Colxx md="4" sm="4" lg="4" xxs="12">
                <AmadeusIntegration
                  LoadIntegrations={LoadIntegrations}
                  visible={isAddAmadeus}
                  toggle={() => {
                    setIsAmadeus(!isAddAmadeus);
                  }}
                />
              </Colxx>
              <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
            </Row>
          </Colxx>
        </Row>
      ) : null}
       {isMews ? (
        <Row>
          <Colxx xxs="12">
            <Row>
              <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              <Colxx md="4" sm="4" lg="4" xxs="12">
                <MewsIntegration
                  LoadIntegrations={LoadIntegrations}
                  visible={isMews}
                  toggle={() => {
                    setIsMews(!isMews);
                  }}
                />
              </Colxx>
              <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
            </Row>
          </Colxx>
        </Row>
      ) : null}
      {isGTM ? (
        <Row>
          <Colxx xxs="12">
            <Row>
              <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              <Colxx md="4" sm="4" lg="4" xxs="12">
                <GTMIntegration
                  LoadIntegrations={LoadIntegrations}
                  visible={isGTM}
                  toggle={() => {
                    setIsGTM(!isGTM);
                  }}
                />
              </Colxx>
              <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
            </Row>
          </Colxx>
        </Row>
      ) : null}
        {isPayPal ? (
        <Row>
          <Colxx xxs="12">
            <Row>
              <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              <Colxx md="4" sm="4" lg="4" xxs="12">
                <PayPalIntegration
                  LoadIntegrations={LoadIntegrations}
                  visible={isPayPal}
                  toggle={() => {
                    setIsPayPal(!isPayPal);
                  }}
                />
              </Colxx>
              <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
            </Row>
          </Colxx>
        </Row>
      ) : null}
      {isCloudBeds ? (
        <Row>
          <Colxx xxs="12">
            <Row>
              <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              <Colxx md="4" sm="4" lg="4" xxs="12">
                <CloudsBedsIntegration
                 userRole={userRole}
                 label={"Cloud Beds"}                 
                 allProperties={allProperties}
                 LoadIntegrations={LoadIntegrations}
                 refreshConnection={RefreshStandardConnection}
                 visible={isCloudBeds}
                  toggle={() => {
                    setIsCloudsBeds(!isCloudBeds);
                  }}
                />
              </Colxx>
              <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
            </Row>
          </Colxx>
        </Row>
      ) : null}
      {isAddVouchers ? (
        <Row>
          <Colxx xxs="12">
            <Row>
              <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              <Colxx md="4" sm="4" lg="4" xxs="12">
                <AddVoucherIntregation
                  visible={isAddVouchers}
                  LoadIntegrations={LoadIntegrations}
                  toggle={() => {
                    setIsAddVouchers(!isAddVouchers);
                  }}
                />
              </Colxx>
              <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
            </Row>
          </Colxx>
        </Row>
      ) : null}
       {isAddXola ? (
        <Row>
          <Colxx xxs="12">
            <Row>
              <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              <Colxx md="4" sm="4" lg="4" xxs="12">
                <XolaIntegration
                  visible={isAddXola}
                  LoadIntegrations={LoadIntegrations}
                  toggle={() => {
                    setIsAddXola(!isAddXola);
                  }}
                />
              </Colxx>
              <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
            </Row>
          </Colxx>
        </Row>
      ) : null}
             {customStripe ? (
        <Row>
          <Colxx xxs="12">
            <Row>
              <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              <Colxx md="4" sm="4" lg="4" xxs="12">
                <CustomStripeIntegration
                  visible={customStripe}
                  integration={customStripeIntegration_data}
                  LoadIntegrations={LoadIntegrations}                  
                  refreshConnection={RefreshConnection}
                  toggle={() => {
                    setCustomStripeIntegration(!customStripe)
                  }}
                />
              </Colxx>
              <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
            </Row>
          </Colxx>
        </Row>
      ) : null}
      {isAddStandalonePage ? (
        <Row>
          <Colxx xxs="12">
            <Row>
              <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              <Colxx md="4" sm="4" lg="4" xxs="12">
                <AddVoucherStandlonePageIntegration
                  visible={isAddStandalonePage}
                  LoadIntegrations={LoadIntegrations}
                  toggle={() => {
                    setIsAddStandalonePage(!isAddStandalonePage);
                  }}
                />
              </Colxx>
              <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
            </Row>
          </Colxx>
        </Row>
      ) : null}
      
       {isAddEmbedVoucher ? (
        <Row>
          <Colxx xxs="12">
            <Row>
              <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              <Colxx md="4" sm="4" lg="4" xxs="12">
                <AddEmbedVoucherIntregation
                  visible={isAddEmbedVoucher}
                  LoadIntegrations={LoadIntegrations}
                  toggle={() => {
                    setIsAddEmbedVoucher(!isAddEmbedVoucher);
                  }}
                />
              </Colxx>
              <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
            </Row>
          </Colxx>
        </Row>
      ) : null}


     
     <Row className="m-2 my-3">    
     <Colxx xxs="12" className="mb-3">
              <h1 style={{ fontSize: "1.5rem" }}>Available Integrations</h1>
              <Separator></Separator>
            </Colxx>
            <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
              <Card className="d-flex flex-row integrationcard" style={{ height: '215px' }}>
                <CardBody className="mt-0">
                  <div className='connect-title'>
                    <div className="integrationChannel mt-2">
                      <img src={aiva_logo} style={{ width: "7rem" }}></img>
                    </div>
                    <Button
                      size="xs"
                      color="primary"
                      outline
                      onClick={() => setIsAddVouchers(!isAddVouchers)}>Connect</Button>
                  </div>
                  <Row>
                    <Colxx xxs="12" className="mb-5" style={{ marginTop: "2rem" }}>
                      <div className="text-left">
                        <h2>Popup Store</h2>
                        <span>Open the voucher store as a popup inside your website (iFrame).</span>
                      </div>
                    </Colxx>
                  </Row>
                </CardBody>
              </Card>
            </Colxx>
            <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
              <Card className="d-flex flex-row integrationcard" style={{ height: '215px' }}>
                <CardBody className="mt-0">
                  <div className='connect-title'>
                    <div className="integrationChannel mt-2">
                      <img src={aiva_logo} style={{ width: "7rem" }}></img>
                    </div>
                    <Button
                      size="xs"
                      color="primary"
                      outline
                      onClick={() => setIsAddStandalonePage(!isAddStandalonePage)}>Connect</Button>
                  </div>
                  <Row>
                    <Colxx xxs="12" className="mb-5" style={{ marginTop: "2rem" }}>
                      <div className="text-left">
                        <h2>Standalone Store</h2>
                        <span>Create a customized voucher store and link from your website.</span>
                      </div>
                    </Colxx>
                  </Row>
                </CardBody>
              </Card>
            </Colxx>

            <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
              <Card className="d-flex flex-row integrationcard" style={{ height: '215px' }}>
                <CardBody className="mt-0">
                  <div className='connect-title'>
                    <div className="integrationChannel mt-2">
                      <img src={aiva_logo} style={{ width: "7rem" }}></img>
                    </div>
                    <Button
                      size="xs"
                      color="primary"
                      outline
                      onClick={() => setIsAddEmbedVoucher(!isAddEmbedVoucher)}>Connect</Button>
                  </div>
                  <Row>
                    <Colxx xxs="12" className="mb-5" style={{ marginTop: "2rem" }}>
                      <div className="text-left">
                        <h2>Embedded Store</h2>
                        <span>Display vouchers inside your webpage (iFrame).</span>
                      </div>
                    </Colxx>
                  </Row>
                </CardBody>
              </Card>
            </Colxx>
            <Colxx xxs="12" className="mb-3">
              <h1 style={{ fontSize: "1.5rem" }}>Connected Integrations</h1>
              <Separator></Separator>
            </Colxx>
        {voucherStandalonePageIntregation
          ? voucherStandalonePageIntregation.map((integration, index) => {
            return (
              <Fragment key={index}>
                <VoucherStandalonePageIntregationThumb
                  integration={integration}
                  allProperties={allProperties}
                  LoadIntegrations={LoadIntegrations}
                    />
              </Fragment> 
            );
          })
          : null}
        {embedVoucherIntregation
          ? embedVoucherIntregation.map((integration, index) => {
            return (
              <Fragment key={index}>
                <EmbedVoucherWebsiteIntregationThumb
                  integration={integration}
                  allProperties={allProperties}
                  LoadIntegrations={LoadIntegrations}
                    />
              </Fragment> 
            );
          })
          : null}
           {voucherWebsiteIntregation
          ? voucherWebsiteIntregation.map((integration, index) => {
            return (
              <Fragment key={index}>
                <VoucherWebsiteIntregationThumb
                  integration={integration}
                  allProperties={allProperties}
                  LoadIntegrations={LoadIntegrations}
                />
              </Fragment>
            );
          })
          : null}
       
       </Row>
       </TabPane>
       <TabPane tabId="applications" className="chat-app-tab-pane" style={{ background: "none" }}>

       <Row className="m-2 my-3">
       <Colxx xxs="12" className="mb-3">
              <h1 style={{ fontSize: "1.5rem" }}>Available Integrations</h1>
              <Separator></Separator>
            </Colxx>
       <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
            <Card
              className="d-flex flex-row integrationcard"
              style={{ height: '215px' }}
              onClick={() => setIsAmadeus(!isAddAmadeus)}
            >
              <div className="position-relative">
                <h3 className="integrationChannel">
                  <img
                    src={AmadeusLogo}
                    alt="Logo"
                    style={{ maxWidth: '100px' }}
                  />
                </h3>
              </div>
              <CardBody>
                <Row>
                  <Colxx xxs="12" className="mb-5 mt-5">
                    <div className="text-center">
                      <div className="mb-1">
                        <h1 className="iconsminds-add" />
                      </div>
                      <h2>Connect Amadeus for Stay Vouchers</h2>
                    </div>
                  </Colxx>
                </Row>
              </CardBody>
            </Card>
          </Colxx>
          <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
          <Card
            className="d-flex flex-row integrationcard"
            style={{ height: '215px' }}
            onClick={() => setIsAddXola(!isAddXola)}
          >
            <div className="position-relative">
              <h3 className="integrationChannel">
                {' '}
                <img
                    src={XolaLogo}
                    alt="Logo"
                    style={{ maxWidth: '100px' }}
                  />
              </h3>
            </div>
            <CardBody>
              <Row>
                <Colxx xxs="12" className="mb-5 mt-5">
                  <div className="text-center">
                    <div className="mb-1">
                      <h1 className="iconsminds-add" />
                    </div>
                    <h2>Connect Xola for Tour & Activity Vouchers</h2>
                  </div>
                </Colxx>
              </Row>
            </CardBody>
          </Card>
        </Colxx>      
        <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
          <Card
            className="d-flex flex-row integrationcard"
            style={{ height: '215px' }}
            onClick={() => setIsCloudsBeds(!isCloudBeds)}
          >
            <div className="position-relative">
              <h3 className="integrationChannel">
                {' '}
                <img
                    src={CloudBeds_Logo}
                    alt="Logo"
                    style={{ maxWidth: '100px' }}
                  />
              </h3>
            </div>
            <CardBody>
              <Row>
                <Colxx xxs="12" className="mb-5 mt-5">
                  <div className="text-center">
                    <div className="mb-1">
                      <h1 className="iconsminds-add" />
                    </div>
                    <h2>Connect CloudBeds</h2>
                  </div>
                </Colxx>
              </Row>
            </CardBody>
          </Card>
        </Colxx>    
        <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
          <Card
            className="d-flex flex-row integrationcard"
            style={{ height: '215px' }}
            onClick={() => SetIsStandardStripe(!isStandardStripe)}
          >
            <div className="position-relative">
              <h3 className="integrationChannel stripe-logo">
                {' '}
                <FontAwesomeIcon icon={faStripe}></FontAwesomeIcon>{' '}
              </h3>
            </div>
            <CardBody>
              <Row>
                <Colxx xxs="12" className="mb-5 mt-5">
                  <div className="text-center">
                    <div className="">
                      <h1 className="iconsminds-add" />
                    </div>
                    <p><b>New to Stripe?</b></p>
                    <h2>Create a New Standard Stripe Account for Payment Processing</h2>
                  </div>
                </Colxx>
              </Row>
            </CardBody>
          </Card>
        </Colxx>
        <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
          <Card
            className="d-flex flex-row integrationcard"
            style={{ height: '215px' }}
            onClick={() => setIsMews(!isMews)}
          >
            <div className="position-relative">
            <h3 className="integrationChannel">
                  <img
                    src={MewsLogo}
                    alt="Logo"
                    style={{ maxWidth: '50px' }}
                  />
                </h3>
            </div>
            <CardBody>
              <Row>
                <Colxx xxs="12" className="mb-5 mt-5">
                  <div className="text-center">
                    <div className="">
                      <h1 className="iconsminds-add" />
                    </div>
                    <h2>Connect to Mews</h2>
                  </div>
                </Colxx>
              </Row>
            </CardBody>
          </Card>
        </Colxx>
        <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
          <Card
            className="d-flex flex-row integrationcard"
            style={{ height: '215px' }}
            onClick={() => setIsPayPal(!isPayPal)}
          >
            <div className="position-relative">
              <h3 className="integrationChannel stripe-logo">
                {' '}
                <FontAwesomeIcon icon={faPaypal}></FontAwesomeIcon>{' '}
              </h3>
            </div>
            <CardBody>
              <Row>
                <Colxx xxs="12" className="mb-5 mt-5">
                  <div className="text-center">
                    <div className="">
                      <h1 className="iconsminds-add" />
                    </div>
                    <h2>Connect to PayPal</h2>
                  </div>
                </Colxx>
              </Row>
            </CardBody>
          </Card>
        </Colxx>
        <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
          <Card
            className="d-flex flex-row integrationcard"
            style={{ height: '215px' }}
            onClick={() => setIsGTM(!isGTM)}
          >
            <div className="position-relative">
              <h3 className="integrationChannel stripe-logo">
                {' '}
                <FontAwesomeIcon icon={faGoogle}></FontAwesomeIcon>{' '}
              </h3>
            </div>
            <CardBody>
              <Row>
                <Colxx xxs="12" className="mb-5 mt-5">
                  <div className="text-center">
                    <div className="">
                      <h1 className="iconsminds-add" />
                    </div>
                    <h2>Connect to Google Tag Manager</h2>
                  </div>
                </Colxx>
              </Row>
            </CardBody>
          </Card>
        </Colxx>
        {/* <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
          <Card
            className="d-flex flex-row integrationcard"
            style={{ height: '215px' }}
            onClick={() => setCustomStripeIntegration(!customStripe)}
          >
            <div className="position-relative">
              <h3 className="integrationChannel stripe-logo">
                {' '}
                <FontAwesomeIcon icon={faStripe}></FontAwesomeIcon>{' '}
              </h3>
            </div>
            <CardBody>
              <Row>
                <Colxx xxs="12" className="mb-5 mt-5">
                  <div className="text-center">
                    <div className="">
                      <h1 className="iconsminds-add" />
                    </div>
                    <p><b>Already using Stripe?</b></p>
                    <h2>Connect to Existing Stripe Account for Payment Processing</h2>
                  </div>
                </Colxx>
              </Row>
            </CardBody>
          </Card>
        </Colxx> */}
        <Colxx xxs="12" className="mb-3">
              <h1 style={{ fontSize: "1.5rem" }}>Connected Integrations</h1>
              <Separator></Separator>
            </Colxx>
        {customStripeIntegration_data
          ? customStripeIntegration_data.map((integration, index) => {
            return (
              <Fragment key={index}>
                <CustomStripeIntegrationThumb
                  userRole={userRole}
                  integration={integration}
                  allProperties={allProperties}
                  LoadIntegrations={LoadIntegrations}
                  refreshConnection={RefreshConnection}
                />
              </Fragment>
            );
          })
          : null}
         {payPalIntegration
          ? payPalIntegration.map((integration, index) => {
            return (
              <Fragment key={index}>
                <PayPalIntegrationThumb
                  userRole={userRole}
                  integration={integration}
                  allProperties={allProperties}
                  LoadIntegrations={LoadIntegrations}
                  refreshConnection={RefreshConnection}
                />
              </Fragment>
            );
          })
          : null}
          {gTMIntegration
          ? gTMIntegration.map((integration, index) => {
            return (
              <Fragment key={index}>
                <GTMIntegrationThumb
                  userRole={userRole}
                  integration={integration}
                  allProperties={allProperties}
                  LoadIntegrations={LoadIntegrations}
                  refreshConnection={RefreshConnection}
                />
              </Fragment>
            );
          })
          : null}
        {stripeIntregation
          ? stripeIntregation.map((integration, index) => {
            if(integration.channelDetails !=null){
            return (
              <Fragment key={index}>
                <StripeIntregationThumb
                  userRole={userRole}       
                  label=""           
                  integration={integration}
                  allProperties={allProperties}
                  LoadIntegrations={LoadIntegrations}
                  refreshConnection={RefreshConnection}
                />
              </Fragment>
            );
            }
          })
          : null}
          {cloudBeds ? cloudBeds.map((integration, index) => {
            return (
              <Fragment key={index}>
                <CloudsBedsIntegrationThumb
                   integration={integration}                   
                   refreshConnection={RefreshConnection}
                   allProperties={allProperties}
                   LoadIntegrations={LoadIntegrations}
                />
              </Fragment>
            );
          })
          : null}

        {standardStripeIntregation
          ? standardStripeIntregation.map((integration, index) => {
            if(integration.channelDetails !=null){
            return (
              <Fragment key={index}>
                <StripeIntregationThumb
                  userRole={userRole}
                  label={"Standard Stripe"}
                  integration={integration}
                  allProperties={allProperties}
                  LoadIntegrations={LoadIntegrations}
                  refreshConnection={RefreshStandardConnection}
                />
              </Fragment>
            );
            }
          })
          : null}
 
           {amadeusIntegration
          ? amadeusIntegration.map((integration, index) => {
            return (
              <Fragment key={index}>
                <AmadeusIntegrationThumb
                  integration={integration}
                  allProperties={allProperties}
                  LoadIntegrations={LoadIntegrations}
                />
              </Fragment>
            );
          })
          : null}
           {mewsIntegration
          ? mewsIntegration.map((integration, index) => {
            if(integration.channelDetails !==null)
            return (
              <Fragment key={index}>
                <MewsIntegrationThumb
                  integration={integration}
                  allProperties={allProperties}
                  LoadIntegrations={LoadIntegrations}
                />
              </Fragment>
            );
          })
          : null}
        {xolaIntegration
          ? xolaIntegration.map((integration, index) => {
            return (
              <Fragment key={index}>
                <XolaIntegrationThumb
                  integration={integration}
                  allProperties={allProperties}
                  LoadIntegrations={LoadIntegrations}
                    />
              </Fragment> 
            );
          })
          : null}
      </Row>

            </TabPane>
</TabContent>
      <StripeIntregation
        formLabel="Payment Methods in NewZeland"
        paymentmodelvisible={paymentmodelvisible}
        toggle={() => {
          setpaymentmodelvisible(!paymentmodelvisible);
        }}
        label=""
        allProperties={allProperties}
        integration={stripeIntregation}
        LoadIntegrations={LoadIntegrations}
        refreshConnection={RefreshConnection}
        handleProerptyId={handleProerptyId}
        handlePayment={() => {
          checkConnection();
          setpaymentmodelvisible(!paymentmodelvisible);
          setcreateaccountModel(!createaccountModel);
        }}
      />
       <StripeIntregation
        formLabel="Payment Methods in NewZeland"
        paymentmodelvisible={isStandardStripe}
        toggle={() => {
          SetIsStandardStripe(!SetIsStandardStripe);
        }}
        allProperties={allProperties}
        label="Standard"
        integration={standardStripeIntregation}
        LoadIntegrations={LoadIntegrations}
        refreshConnection={RefreshStandardConnection}
        handleProerptyId={handleProerptyId}
        handlePayment={() => {
          checkStandardConnection();
          SetIsStandardStripe(!isStandardStripe);
          setStandardAccountModel(!standardAccountModel);
        }}
      />
      <OpenAccount
        visible={createaccountModel}
        toggle={() => {
          setcreateaccountModel(!createaccountModel);
        }}
        createAccount={() => {
          handlePayment();          
        }}
        deleteAccount={() => {
          stripeIntregation &&
            stripeIntregation.map((integration, index) => {
              handleDelete(integration.id);
              RefreshConnection(
                'Archieve',
                integration.channelDetails.stripeCustomerId
              );
            });
        }}
        isConnected={isConnected}
      />
      <OpenAccount
        visible={standardAccountModel}
        toggle={() => {
          setStandardAccountModel(!standardAccountModel);
        }}
        createAccount={() => {          
          handleStandardPayment();
        }}
        deleteAccount={() => {
          standardStripeIntregation &&
             standardStripeIntregation.map((integration, index) => {
              handleDelete(integration.id);
              RefreshConnection(
                'Archieve',
                integration.channelDetails.stripeCustomerId
              );
            });
        }}
        isConnected={isConnected}
      />
      <ShowMessage
        formbody={'Connection established'}
        visible={messageVisible}
        logo={stripe_logo}
        toggle={() => {
          localStorage.removeItem('ShowMessage');
          localStorage.removeItem('Message');
          setmessageVisible(!messageVisible);
        }}
      />
      <ShowMessage
        formbody={'Connection established'}
        visible={cloudBedsVisible}
        logo={CloudBeds_Logo}
        toggle={() => {
          localStorage.removeItem('cloudbedsId');
          localStorage.removeItem('ShowCloudbedsMessage');
          setCloudsBedsVisible(!cloudBedsVisible);
        }}
      />


    </Fragment>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, email, isVoucherEngine, domains ,userRole} = settings;
  return {
    propertyId,
    email,
    isVoucherEngine,
    domains,
    userRole
  };
};

export default injectIntl(connect(mapStateToProps, {})(Integrations));
